import React, { useState } from 'react';
import { Container } from 'reactstrap';
import { Redirect, useParams } from 'react-router-dom';
import _ from 'lodash';
import Block from '../common/Display/Block';
import ManuelSale from './ManuelSale';
import Actions from './Actions';
import ExpressSale from './ExpressSale';
import { useAutobizTradePage } from '../../hooks/useAutobizTrade/useAutobizTradePage';
import SaleParameters from './SaleParameters';
import HistorySale from './HistorySale';

const AutobizTrade = (props) => {
  const { recordId } = useParams();
  const [redirect, setRedirect] = useState(null);
  const {
    pdv,
    offersLoading,
    offersErrorApi,
    status: tradeStatus,
    actions,
    showBlocPending,
    postOffer,
    postAnnonceAt,
    showForm,
    offers,
    sales,
    showParameters,
    showOffers,
    offersTitle,
    disableCta,
    showManualTitle,
    supOfferId,
    counterInspection,
    recordTypeId,
    expertiseCosts,
  } = useAutobizTradePage({
    recordId,
  });

  const view = (
    <>
      {redirect && (
        <Redirect
          to={{
            pathname: redirect,
          }}
        />
      )}

      <Block
        {...props}
        backRoute={_.set(props, 'location.state.from', `/files/${recordId}`)}
        showSubHeader
        page="Push_to_autobizTrade"
      >
        <Container fluid>
          <Actions {...props} actions={actions} disabelActions={!showForm} disableCta={disableCta} />
          <>
            {tradeStatus && (
              <SaleParameters
                pdv={pdv}
                tradeStatus={tradeStatus}
                showBlocPending={showBlocPending}
                sales={sales}
                offers={offers}
                showParameters={showParameters}
                showOffers={showOffers}
                offersTitle={offersTitle}
                offersLoading={offersLoading}
                offersErrorApi={offersErrorApi}
                supOfferId={supOfferId}
              />
            )}

            {actions.showManuelSale && (
              <ManuelSale
                {...props}
                postOffer={postOffer}
                postAnnonceAt={postAnnonceAt}
                showForm={showForm}
                offers={offers}
                showManualTitle={showManualTitle}
                counterInspection={counterInspection}
                recordTypeId={recordTypeId}
                expertiseCosts={expertiseCosts}
              />
            )}
            {actions.showExpressSale && (
              <ExpressSale
                isOpen={actions.showExpressSale}
                setShowExpressSale={actions.setShowExpressSale}
                postOffer={postOffer}
                postAnnonceAt={postAnnonceAt}
                recordId={recordId}
                setRedirect={setRedirect}
              />
            )}
            {actions.showHistoryAt && (
              <HistorySale isOpen={actions.showHistoryAt} handleClose={actions.setShowHistoryAt} />
            )}
          </>
        </Container>
      </Block>
    </>
  );

  return view;
};

export default AutobizTrade;
